import { ArrowDown, ArrowUp } from 'lucide-react';
import React from 'react';
import Counter from '@/shared/components/ui/Counter/Counter';
import { useColorStore } from '@/store/colorStore';
import { useSettingsStore } from '@/store/useSettingsStore';

interface CardVolumeVehicleProps {
  title: string;
  totalVehicle: number;
  typeArrow?: 'up' | 'down';
  // Signed day-over-day change. When provided it replaces the placeholder;
  // `null` renders as "—" (no baseline). Omitted keeps the legacy placeholder.
  percentage?: number | null;
}

const CardVolumeVehicle = ({
  title,
  totalVehicle,
  typeArrow = 'up',
  percentage,
}: CardVolumeVehicleProps) => {
  const { NEWCOLOR } = useColorStore();
  const counterAnimationEnabled = useSettingsStore((state) => state.counterAnimationEnabled);

  const Icon = typeArrow === 'up' ? ArrowUp : ArrowDown;
  const color = typeArrow === 'up' ? NEWCOLOR.danger : NEWCOLOR.greenPrimary;

  const trendLabel =
    percentage === null || percentage === undefined
      ? '0.0%'
      : `${percentage > 0 ? '+' : ''}${percentage.toFixed(1)}%`;

  const renderTotalVehicle = () => {
    if (counterAnimationEnabled && typeof totalVehicle === 'number') {
      return <Counter value={totalVehicle} />;
    }
    return totalVehicle;
  };

  return (
    <div className="flex relative group gap-[4px]  flex-col justify-between w-full h-full rounded-[12px] border p-3 shadow-[0_4px_4px_0_rgba(0,0,0,0.16)] dark:bg-[#F3F6FE]/10">
      <span className="title2 uppercase text-text-grey text-ellipsis w-full line-clamp-1 group-hover:line-clamp-none group-hover:whitespace-nowrap group-hover:overflow-visible overflow-hidden">
        {title}
      </span>

      {/* <span className="title2 uppercase text-text-grey text-ellipsis w-full line-clamp-1 group-hover:line-clamp-2 overflow-hidden">
        {title}
      </span> */}

      <span className="h3bold ">{renderTotalVehicle()}</span>

      <div className="inline-flex items-center gap-2">
        <Icon size={18} color={color} />
        <span className="title2" style={{ color }}>
          {trendLabel}
        </span>
      </div>
    </div>
  );
};

export default CardVolumeVehicle;
